import Link from "next/link";

const ProductPageSellerInfo = ({ seller }) => {
  const { name, url_key } = seller;

  return (
    <div className="text-[14px]">
      Vandut si livrat de:{" "}
      <Link href={`/vendor/${url_key}`}>
        <a title={name} className="text-[#1D4ED8] underline font-medium">
          {name}
        </a>
      </Link>
    </div>
  );
};

export default ProductPageSellerInfo;
